import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-3 text-end" }
const _hoisted_5 = { class: "d-grid" }
const _hoisted_6 = {
  class: "btn btn-secondary mb-1",
  type: "submit",
  id: "submit"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "card-text fs-5 text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "card-text fs-5 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoTitle = _resolveComponent("LogoTitle")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_MainCard = _resolveComponent("MainCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LogoTitle, {
      title: _ctx.$t('meta.pageTitles.login')
    }, null, 8, ["title"]),
    _createVNode(_component_MainCard, null, {
      default: _withCtx(() => [
        _createVNode(_component_Alerts, { sticky: "sticky-top" }),
        _createElementVNode("h2", _hoisted_1, [
          (_ctx.goingToAdmin)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('auth.login_title_admin')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('auth.login_title')), 1))
        ]),
        _createVNode(_component_Form, {
          onSubmit: _ctx.signIn,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormInput, {
              type: "text",
              label: _ctx.$t('auth.login_username'),
              name: "username"
            }, null, 8, ["label"]),
            _createVNode(_component_FormInput, {
              type: "password",
              label: _ctx.$t('auth.login_password'),
              name: "password"
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/auth/reset",
                class: "fs-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('auth.login_forgot_password')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('auth.login_title')), 1)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]),
        _hoisted_7,
        (!_ctx.goingToAdmin)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('auth.login_base_text')) + " ", 1),
              _createVNode(_component_router_link, { to: "/registration" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('auth.login_go_to_register')), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t('auth.login_going_to_applicant')) + " ", 1),
              _createElementVNode("a", {
                href: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeToAdmin()))
              }, _toDisplayString(_ctx.$t('auth.login_for_applicant')), 1)
            ]))
      ]),
      _: 1
    })
  ], 64))
}